import APP_ROUTES from '@src/app_routes';
import axios from 'axios';
import deep from 'deep-get-set';
import Immutable from 'immutable';
import { push } from 'react-router-redux';
import { createAction } from 'redux-api-middleware';
import { createSelector } from 'reselect';
import store from 'store2';
import config from '@src/config';
import { IMPERSONATED_USER_ID, ORGANIZATION_ID } from '@src/constants/local-storage-ids';

const LOAD = 'auth/LOAD';
const LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
const LOAD_FAIL = 'auth/LOAD_FAIL';

const SHOPIFY_UPDATE_SUCCESS = 'auth/SHOPIFY_UPDATE_SUCCESS';

const LOADUSERDETAIL = 'auth/LOADUSERDETAIL';
const LOADUSERDETAIL_SUCCESS = 'auth/LOADUSERDETAIL_SUCCESS';
const LOADUSERDETAIL_FAIL = 'auth/LOADUSERDETAIL_FAIL';

const LOAD_SIGNUP_FORM_OPTS = 'auth/LOAD_SIGNUP_FORM_OPTS';
const LOAD_SIGNUP_FORM_OPTS_SUCCESS = 'auth/LOAD_SIGNUP_FORM_OPTS_SUCCESS';
const LOAD_SIGNUP_FORM_OPTS_FAIL = 'auth/LOADUSERDETAIL_FAIL';

const LOGIN = 'auth/LOGIN';
const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'auth/LOGIN_FAIL';

const SIGNUP = 'auth/SIGNUP';
const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS';
const SIGNUP_FAIL = 'auth/SIGNUP_FAIL';

const SPECIAL_SIGNUP = 'auth/SPECIAL_SIGNUP';
const SPECIAL_SIGNUP_SUCCESS = 'auth/SPECIAL_SIGNUP_SUCCESS';
const SPECIAL_SIGNUP_FAIL = 'auth/SPECIAL_SIGNUP_FAIL';

const CHECK_SIGNUP = 'auth/CHECK_SIGNUP';
const CHECK_SIGNUP_SUCCESS = 'auth/CHECK_SIGNUP_SUCCESS';
const CHECK_SIGNUP_FAIL = 'auth/CHECK_SIGNUP_FAIL';

const FORGOTPASSWORD = 'auth/FORGOTPASSWORD';
const FORGOTPASSWORD_SUCCESS = 'auth/FORGOTPASSWORD_SUCCESS';
const FORGOTPASSWORD_FAIL = 'auth/FORGOTPASSWORD_FAIL';

const RESETPASSWORD = 'auth/RESETPASSWORD';
const RESETPASSWORD_SUCCESS = 'auth/RESETPASSWORD_SUCCESS';
const RESETPASSWORD_FAIL = 'auth/RESETPASSWORD_FAIL';

const UPDATEEMAIL_SUCCESS = 'auth/UPDATEEMAIL_SUCCESS';
const UPDATEEMAIL_FAIL = 'auth/UPDATEEMAIL_FAIL';

const LOAD_USERS = 'auth/LOAD_USERS';
const LOAD_USERS_SUCCESS = 'auth/LOAD_USERS_SUCCESS';
const LOAD_USERS_FAIL = 'auth/LOAD_USERS_FAIL';

const SAVE_USER = 'auth/SAVE_USER';
const SAVE_USER_SUCCESS = 'auth/SAVE_USER_SUCCESS';
const SAVE_USER_FAIL = 'auth/SAVE_USER_FAIL';

const IMPERSONATE = 'auth/IMPERSONATE';
const IMPERSONATE_FAIL = 'auth/IMPERSONATE_FAIL';

const END_IMPERSONATION = 'auth/END_IMPERSONATION';
const IMPERSONATE_SUCCESS = 'auth/IMPERSONATE_SUCCESS';
const END_IMPERSONATION_SUCCESS = 'auth/END_IMPERSONATION_SUCCESS';
const END_IMPERSONATION_FAIL = 'auth/END_IMPERSONATION_FAIL';

export const IS_SSO_SET = 'auth/IS_SSO_SET';

const LOGOUT = 'auth/LOGOUT';

const FLUSH = 'auth/FLUSH';

export const SSO_SUBMIT_LOAD = 'auth/SSO_SUBMIT_LOAD';
export const SSO_SUBMIT_LOAD_FAILURE = 'auth/SSO_SUBMIT_LOAD_FAILURE';
export const SSO_SUBMIT_LOAD_SUCCESS = 'auth/SSO_SUBMIT_LOAD_SUCCESS';

// Action creators
export const submitForSso = (email) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.authSso}`,
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: {
      'Content-Type': 'application/json'
    },
    types: [SSO_SUBMIT_LOAD, SSO_SUBMIT_LOAD_SUCCESS, SSO_SUBMIT_LOAD_FAILURE]
  });

export function setIsSso(status) {
  return {
    type: IS_SSO_SET,
    status
  };
}

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  hasInitiallyLoaded: false,

  isLogin: false,
  loginErr: null,

  user: null,
  isSso: false,
  isSubmittingForSso: false,
  hasSsoSubmitError: false,
  ssoRedirectInfo: null,

  old_user: {
    user: null
  },
  clientCount: 0,
  clients: [],

  loading: false,
  signupError: null,
  signup: null,
  // signupInfo persists some of the data that was used during signup so that we can make decisions off of it(like redirects)
  signupInfo: null,

  signupFormOpts: {
    availableBudgets: null,
    industry: [],
    referralSource: []
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set('isLoad', true).set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('hasInitiallyLoaded', true)
        .set('user', action.user)
        .set('isSso', action.user?.ssoUser || false);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('hasInitiallyLoaded', true)
        .set('loadErr', action.error)
        .set('user', null);

    case SHOPIFY_UPDATE_SUCCESS:
      return state.set('isLoad', false).set('user', action.user);

    case LOADUSERDETAIL:
      return state.set('isLoad', true).set('loadErr', null);

    case LOADUSERDETAIL_SUCCESS:
      return state.set('isLoad', false).set('user', action.user);

    case LOADUSERDETAIL_FAIL:
      return state.set('isLoad', false).set('loadErr', action.error).set('user', null);

    case LOAD_SIGNUP_FORM_OPTS:
      return state.set('isLoad', true).set('loadErr', null);

    case LOAD_SIGNUP_FORM_OPTS_SUCCESS:
      return state.set('isLoad', false).set('signupFormOpts', {
        availableBudgets: action.signupFormOpts.availableBudgets.map(({ id, label: text }) => ({
          key: id,
          text,
          value: id
        })),
        industry: action.signupFormOpts.industry.map(({ id, label: text }) => ({
          key: id,
          text,
          value: id
        })),
        referralSource: action.signupFormOpts.referralSource.map(({ id, label: text }) => ({
          key: id,
          text,
          value: id
        }))
      });

    case LOAD_SIGNUP_FORM_OPTS_FAIL:
      return state.set('isLoad', false).set('loadErr', action.error).set('signupFormOpts', null);

    case LOAD_USERS:
      return state.set('isLoad', true).set('loadErr', null);

    case LOAD_USERS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('clients', action.result.rows)
        .set('clientCount', action.result.count);

    case LOAD_USERS_FAIL:
      return state.set('isLoad', false).set('loadErr', action.error).set('clients', []);

    case SAVE_USER:
      return state.set('isLoad', true).set('saveUserErr', null);

    case SAVE_USER_SUCCESS:
      return state.set('isLoad', false);

    case SAVE_USER_FAIL:
      return state.set('isLoad', false).set('saveUserErr', action.error);

    case LOGIN:
      return state.set('isLogin', true).set('loginErr', null);

    case LOGIN_SUCCESS:
      return state.set('isLogin', false);

    case LOGIN_FAIL:
      return state.set('isLogin', false).set('loginErr', action.error).set('user', null);

    case FORGOTPASSWORD:
      return state.set('loading', true).set('forgotPasswordErr', null);

    case FORGOTPASSWORD_SUCCESS:
      return state.set('loading', false).set('forgotPasswordErr', null);

    case FORGOTPASSWORD_FAIL:
      return state.set('loading', false).set('forgotPasswordErr', action.error);

    case RESETPASSWORD:
      return state.set('loading', true).set('resetPasswordErr', null).set('resetUser', null);

    case RESETPASSWORD_SUCCESS:
      return state
        .set('loading', false)
        .set('resetPasswordErr', null)
        .set('resetUser', action.resetUser);

    case RESETPASSWORD_FAIL:
      return state
        .set('loading', false)
        .set('resetPasswordErr', action.error)
        .set('resetUser', null);

    case UPDATEEMAIL_SUCCESS:
      return state.set('loading', false).set('user', action.user);

    case UPDATEEMAIL_FAIL:
      return state.set('loading', false);

    case SIGNUP:
      return state.set('loading', true).set('signupError', null);

    case SIGNUP_SUCCESS:
      return state
        .set('loading', false)
        .set('signupError', null)
        .set('signupInfo', action.signupInfo);

    case SIGNUP_FAIL:
      return state.set('loading', false).set('signupError', action.error).set('signupInfo', null);

    case SPECIAL_SIGNUP:
      return state.set('loading', true).set('signupError', null);

    case SPECIAL_SIGNUP_SUCCESS:
      return state.set('loading', false).set('signupError', null).set('user', action.user);

    case SPECIAL_SIGNUP_FAIL:
      return state.set('loading', false).set('signupError', action.error).set('user', null);

    case CHECK_SIGNUP:
      return state.set('emailloading', true).set('signupError', null);

    case CHECK_SIGNUP_SUCCESS:
      return state.set('emailloading', false).set('signup', action.signup).set('signupError', null);

    case CHECK_SIGNUP_FAIL:
      return state.set('emailloading', false).set('signupError', action.error);

    case IMPERSONATE:
      return state.set('isLoad', true).set('loadErr', null);

    case IMPERSONATE_SUCCESS: {
      localStorage.setItem(IMPERSONATED_USER_ID, action?.result?.id);
      window.location.reload();

      return state.set('isLoad', false).set('old_user', action.old_user).set('user', action.result);
    }

    case IMPERSONATE_FAIL:
      return state.set('isLoad', false).set('loadErr', action.error);

    case END_IMPERSONATION:
      return state.set('isLoad', true).set('loadErr', null);

    case END_IMPERSONATION_SUCCESS: {
      localStorage.removeItem(IMPERSONATED_USER_ID);

      return state.set('isLoad', false).set('user', action.result);
    }

    case END_IMPERSONATION_FAIL:
      return state.set('isLoad', false).set('loadErr', action.error);

    case LOGOUT:
    case FLUSH: {
      return initialState;
    }

    case IS_SSO_SET: {
      return state.set('isSso', action.status);
    }

    case SSO_SUBMIT_LOAD: {
      return state
        .set('isSubmittingForSso', true)
        .set('hasSsoSubmitError', false)
        .set('ssoRedirectInfo', null);
    }

    case SSO_SUBMIT_LOAD_FAILURE: {
      return state
        .set('isSubmittingForSso', false)
        .set('hasSsoSubmitError', true)
        .set('ssoRedirectInfo', action.payload);
    }

    case SSO_SUBMIT_LOAD_SUCCESS: {
      return state
        .set('isSubmittingForSso', false)
        .set('hasSsoSubmitError', false)
        .set('ssoRedirectInfo', action.payload);
    }

    default:
      return state;
  }
}

export const load =
  (forced, shopifyToken = null) =>
  async (dispatch, getState, api) => {
    // calling api is necessary if there is shopify token
    if (!shopifyToken) {
      // dont call api if user data is in state
      const user = getState().get('auth').get('user');
      if (user && !forced) {
        return;
      }
    }
    dispatch({ type: LOAD });

    let res;
    try {
      res = await api.get('/sessions');
      if (res?.message) {
        dispatch({ type: LOAD_FAIL, error: res?.message });
        return;
      }
      if (res?.selectedOrganizationId) {
        localStorage.setItem(ORGANIZATION_ID, res?.selectedOrganizationId);
      }
    } catch (error) {
      dispatch({ type: LOAD_FAIL, error });
      return;
    }

    const fileUploadEnabled = res?.featurePermissions?.ATTACHMENT_UPLOAD_ENABLED?.value;
    const fileAuthJwt = res?.fileAuthJwt;
    if (fileUploadEnabled && fileAuthJwt) {
      axios
        .post(
          `${config.AWS.attachmentsCloudfrontUrl}/auth/`,
          {},
          {
            withCredentials: true,
            headers: {
              'x-attachments-authorization': fileAuthJwt
            }
          }
        )
        .catch(() => {
          // add a catch to prevent uncaught error exception
          // use .catch instead of try/catch/await to prevent the UI from loading while this request is in progress
        });
    }

    // clear fileAuthJwt so it doesn't persist in the redux store
    const user = res ? { ...res, fileAuthJwt: undefined } : null;

    dispatch({ type: LOAD_SUCCESS, user });

    return res;
  };

export const updateUserWithShopifyToken = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/shopify', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }

    const user = getState().get('auth').get('user');
    user.isShopifyUser = true;
    user.shopifyStore = data.shopifyStore;

    dispatch({ type: SHOPIFY_UPDATE_SUCCESS, user: user });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const userDetail = (reload) => async (dispatch, getState, api) => {
  // dont call api if user data is in state
  const user = getState().get('auth').get('user');
  if (user && !reload) {
    return;
  }

  dispatch({ type: LOADUSERDETAIL });

  try {
    const res = await api.get('/sessions');
    if (res.message) {
      dispatch({ type: LOADUSERDETAIL_FAIL, error: res.message });
      return;
    }
    dispatch({ type: LOADUSERDETAIL_SUCCESS, user: res });
  } catch (error) {
    dispatch({ type: LOADUSERDETAIL_FAIL, error });
  }
};

export const loadSignupFormOptions = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_SIGNUP_FORM_OPTS });

  try {
    const response = await api.get('/v1/form-options');

    if (response.message) {
      dispatch({ type: LOAD_SIGNUP_FORM_OPTS_FAIL, error: response.message });
      return;
    }

    dispatch({
      type: LOAD_SIGNUP_FORM_OPTS_SUCCESS,
      signupFormOpts: response.signup
    });
  } catch (error) {
    dispatch({ type: LOAD_SIGNUP_FORM_OPTS_FAIL, error });
  }
};

export const login = (username, password) => async (dispatch, getState, api) => {
  dispatch({ type: LOGIN });
  try {
    await api.post('/sessions?jwt=1', { data: { username, password } });
    dispatch({ type: LOGIN_SUCCESS });
    window.location.reload();
  } catch (err) {
    dispatch({ type: LOGIN_FAIL, error: err.message });
  }
};

export const getAllUsers =
  (page = 1, params = {}) =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_USERS });
    try {
      const result = await api.get(`/user/all/${page}`, { params });
      if (result.message) {
        dispatch({ type: LOAD_USERS_FAIL, error: result.message });
        return;
      }

      dispatch({ type: LOAD_USERS_SUCCESS, result });
    } catch (error) {
      dispatch({ type: LOAD_USERS_FAIL, error });
    }
  };

export const saveUser = (user) => async (dispatch, getState, api) => {
  dispatch({ type: SAVE_USER });
  try {
    const payload = {
      planId: user.planId,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNumber: user.phoneNumber
    };

    const result = await api.put(`/user/${user.id}/admin-update`, { data: payload });
    if (result.message) {
      dispatch({ type: SAVE_USER_FAIL, error: result.message });
      return;
    }

    dispatch({ type: SAVE_USER_SUCCESS, result });
  } catch (err) {
    dispatch({ type: SAVE_USER_FAIL, error: err.message });
  }
};

export const impersonate = (username) => async (dispatch, getState, api) => {
  dispatch({ type: IMPERSONATE });
  try {
    const result = await api.post('/sessions/impersonate?jwt=1', { data: { username } });
    if (!result) {
      dispatch({ type: IMPERSONATE_FAIL, error: result.Message });
      return;
    }
    // keep old user
    const old_user = {
      user: getState().get('auth').get('user')
    };

    dispatch({ type: IMPERSONATE_SUCCESS, old_user, result: result.user });
    dispatch(push('/campaign'));
  } catch (err) {
    dispatch({ type: IMPERSONATE_FAIL, error: err.message });
  }
};

export const endImpersonation = () => async (dispatch, getState, api) => {
  try {
    dispatch({ type: END_IMPERSONATION });
    await api.del('/sessions/impersonate');
    store.remove('authToken');
    dispatch({ type: END_IMPERSONATION_SUCCESS, result: null });
    dispatch(push('/clients'));
  } catch (e) {
    store.remove('authToken');
    dispatch({ type: END_IMPERSONATION_FAIL, error: e });
    throw e;
  }
};

export const logout = () => async (dispatch, getState, api) => {
  const attachmentUploadEnabled = getState()?.get('auth')?.get('user')?.featurePermissions
    ?.ATTACHMENT_UPLOAD_ENABLED?.value;
  const fileAuthScope =
    getState()?.get('auth')?.get('user')?.fileAuthScope?.authorizedAttachments || [];
  const deletePromises = attachmentUploadEnabled
    ? [
        api.del('/sessions'),
        axios.delete(`${config.AWS.attachmentsCloudfrontUrl}/auth/`, {
          withCredentials: true,
          headers: {
            'x-fileauthscope': fileAuthScope?.join(',')
          }
        })
      ]
    : [api.del('/sessions')];
  await Promise.allSettled(deletePromises);

  store.remove('authToken');
  store.remove(ORGANIZATION_ID);
  localStorage.removeItem(IMPERSONATED_USER_ID);

  dispatch({ type: LOGOUT });
  dispatch({ type: 'FLUSH' });
  dispatch(push(APP_ROUTES.home));
};

export const forgotPassword = (email) => async (dispatch, getState, api) => {
  dispatch({ type: FORGOTPASSWORD });
  try {
    const res = await api.post('/account/forgotPassword', { data: { email } });
    dispatch({ type: FORGOTPASSWORD_SUCCESS, user: res });
  } catch (err) {
    dispatch({ type: FORGOTPASSWORD_FAIL, error: err.message });
  }
};

export const resetPassword = (token) => async (dispatch, getState, api) => {
  dispatch({ type: RESETPASSWORD });
  try {
    const res = await api.get('/account/resetPassword/' + token);
    dispatch({ type: RESETPASSWORD_SUCCESS, resetUser: res });
  } catch (err) {
    dispatch({ type: RESETPASSWORD_FAIL, error: err.message });
  }
};

export const updateUserPass = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    await api.put('/account/resetPassword', { data });
    dispatch({ type: LOAD_SUCCESS });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateEmailAddress = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/email', { data });
    if (res && !res.isError) {
      const user = getState().get('auth').get('user');
      dispatch({ type: UPDATEEMAIL_SUCCESS, user: Object.assign({}, user, { email: data.email }) });
    }
    return res;
  } catch (err) {
    dispatch({ type: UPDATEEMAIL_FAIL });
  }
};

export const signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: SIGNUP });

  try {
    const res = await api.post('/account', { data: obj });

    if (res.message) return dispatch({ type: SIGNUP_FAIL, error: res.message });

    const signupInfo = {
      isFromInvite: !!obj.inviteToken,
      planId: obj.planId
    };

    // we used to dispatch the `user` in this action however that conflicted with LOAD_SUCCESS and made it hard to
    // control when we redirect users to /campaigns - so now we dispatch `signupInfo` in SIGNUP_SUCCESS and `user`
    // in LOAD_SUCCESS
    dispatch({ type: SIGNUP_SUCCESS, signupInfo });
  } catch (err) {
    dispatch({ type: SIGNUP_FAIL, error: err.message });
  }
};

export const changeUserPass = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    await api.put('/account/changePassword', { data });
    return 'Success';
  } catch (err) {
    return 'Fail';
  }
};

export const special_signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: SPECIAL_SIGNUP });
  try {
    const res = await api.post('/account/special', { data: obj });
    if (res.message) {
      return dispatch({ type: SPECIAL_SIGNUP_FAIL, error: res.message });
    }
    dispatch({ type: SPECIAL_SIGNUP_SUCCESS, user: res });
    dispatch(this.load(true));
  } catch (err) {
    dispatch({ type: SPECIAL_SIGNUP_FAIL, error: err.message });
  }
};

export const check_signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: CHECK_SIGNUP });
  try {
    const res = await api.post('/account/check', { data: { username: obj.username } });
    if (res.message) {
      return dispatch({ type: CHECK_SIGNUP_FAIL, error: res.message });
    }
    return dispatch({ type: CHECK_SIGNUP_SUCCESS, data: res, signup: obj });
  } catch (err) {
    dispatch({ type: CHECK_SIGNUP_FAIL, error: err.message });
  }
};

// Selectors
export const getAuthState = createSelector(
  (state) => state,
  (authState) => authState.get('auth')
);

export const getIsAuthLoading = createSelector(getAuthState, (authState) =>
  authState.get('isLoad')
);

export const getUser = createSelector(getAuthState, (authState) => authState.get('user'));

export const getHasInitiallyLoaded = createSelector(getAuthState, (authState) =>
  authState.get('hasInitiallyLoaded')
);

export const getUserName = createSelector(getUser, (user) =>
  user ? `${user.firstName} ${user.lastName}` : ''
);

export const getIsUserAClient = createSelector(getUser, (user) => deep(user, 'role') === 2);

export const getUserId = createSelector(getUser, (user) => deep(user, 'id'));

export const getFeaturePermissions = createSelector(getUser, (user) =>
  deep(user, 'featurePermissions')
);

export const getCampaignLimit = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.NUMBER_OF_CAMPAIGNS_ALLOWED?.value
);

export const getScheduleCallUrl = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.SCHEDULE_CALL_URL?.value
);

export const getThankYouPageImageEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.THANK_YOU_PAGE_IMAGE_ENABLED?.value
);

export const getThankYouPageRedirectEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.THANK_YOU_PAGE_REDIRECT_ENABLED?.value
);

export const getThankYouPageRichTextEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.THANK_YOU_PAGE_RICH_TEXT_ENABLED?.value
);

export const getVideosPerMonthLimit = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.NUMBER_OF_VIDEOS_ALLOWED_PER_MONTH?.value
);

export const getMediaTtl = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ORG_MEDIA_VISIBILITY_DAYS?.value
);

export const getCampaignResponsesCsvLimitEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CAMPAIGN_RESPONSE_CSV_LIMIT_ENABLED?.value
);

export const getCampaignResponsesCsvLimit = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CAMPAIGN_RESPONSE_CSV_LIMIT?.value
);
export const getCanModifyTermsConditions = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CAN_MODIFY_TERMS_CONDITIONS?.value
);
export const getTranscriptionsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.TRANSCRIPTIONS_ENABLED?.value
);

export const getAttachmentUploadEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ATTACHMENT_UPLOAD_ENABLED?.value
);

export const getPublishYoutubeEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PUBLISHING_YOUTUBE_ENABLED?.value
);

export const getCustomSubdomainEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CUSTOM_SUBDOMAIN_ENABLED?.value
);

export const getNumberOfCustomSubdomainsAllowed = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.NUMBER_OF_CUSTOM_SUBDOMAINS_ALLOWED?.value
);

export const getSignatureElementEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.SIGNATURE_ELEMENT_ENABLED?.value
);

export const getEngBillingV2Enabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ENG_BILLING_V2_ENABLED?.value
);

export const getIsSso = createSelector(getAuthState, (authState) => authState.get('isSso'));

export const getIsSsoSubmitting = createSelector(getAuthState, (authState) =>
  authState.get('isSubmittingForSso')
);

export const getHasSsoSubmitError = createSelector(getAuthState, (authState) =>
  authState.get('hasSsoSubmitError')
);

export const getSsoRedirectInfo = createSelector(getAuthState, (authState) =>
  authState.get('ssoRedirectInfo')
);

export const getNewPluginPageEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.NEW_PLUGIN_PAGE_ENABLED?.value
);
export const getAttachmentPluginsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ENG_ATTACHMENTS_PLUGIN_ENABLED?.value
);
export const getPluginStatsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_STATS_ENABLED?.value
);
export const getEngAttachmentTaggingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ENG_ATTACHMENTS_TAGGING_ENABLED?.value
);
export const getApiTokenEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.API_KEY_GENERATION_ENABLED?.value
);
export const getPluginStylesEditingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_STYLES_EDITING_ENABLED?.value
);
export const getPluginRemoveLogoEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_REMOVE_LOGO_ENABLED?.value
);
export const getPluginManagementEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_MANAGEMENT_ENABLED?.value
);
export const getPluginCarouselEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_CAROUSEL_ENABLED?.value
);
export const getPluginGalleryEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_GALLERY_ENABLED?.value
);
export const getPluginListEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_LIST_ENABLED?.value
);
export const getPluginPlaylistEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PLUGIN_PLAYLIST_ENABLED?.value
);

export const getEngCampaignBrandingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ENG_CAMPAIGN_BRANDING_ENABLED?.value
);

export const getPaywallEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.PAYWALL_ENABLED?.value
);

//Baisc Restrictions
export const getCEPPresentationMediaElementsLock = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CEP_PRESENTATION_MEDIA_ELEMENT?.value
);

export const getQRCodeEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CLP_QR_CODE_ENABLED?.value
);

export const getContentTaggingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CONTENT_TAGGING?.value
);

export const getMediaThumbnailEditingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.MEDIA_THUMBNAIL_EDITING?.value
);

export const getBulkDownloadEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.BULK_DOWNLOAD_ENABLED?.value
);

export const getPluginCreationEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CREATE_PLUGINS_ENABLED?.value
);

export const getDownloadOriginalVideoEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.DOWNLOAD_ORIGINAL_VIDEO_ENABLED?.value
);

export const getEngVideoCompilationEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.ENG_VIDEO_COMPILATION_ENABLED?.value
);

export const getVideoCompilationEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.VIDEO_COMPILATION_ENABLED?.value
);

export const getImportingEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.IMPORTING_ENABLED?.value
);

export const getSeoSettingsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.SEO_SETTINGS_ENABLED?.value
);

export const getLanguageSettingsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CAMPAIGN_LANGUAGE_ENABLED?.value
);

export const getMultipleChoiceEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.MULTIPLE_CHOICE_ENABLED?.value
);

export const getContactsEnabled = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.CONTACTS_ENABLED?.value
);

export const getNumberOfMultiuserSeats = createSelector(
  getFeaturePermissions,
  (featurePermissions) => featurePermissions?.MULTIUSER_SEATS?.value
);


// WEBPACK FOOTER //
// ./src/redux/modules/auth.js